
export default function Benefits() {
  const benefits = [
    {
      icon: 'ri-shield-star-line',
      title: 'リース不要のレンタルサービス',
      description: '定期・会計監査を含む様々な場面で柔軟に対応できます。'
    },
    {
      icon: 'ri-infinity-line',
      title: 'カウンター料金なしで無制限',
      description: '人気店舗数が少ない場合でも、印刷枚数を気にせずご利用いただけます。'
    },
    {
      icon: 'ri-time-line',
      title: '1営業日以内に無償対応',
      description: '企業様のオフィスに何度も訪問可能。迅速なサポート体制を整えています。'
    }
  ];

  return (
    <section id="benefits" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            スリホが選ばれる理由
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            業界No.1のシェアを誇るスリホは、お客様のビジネスを強力にサポートします
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-blue-50 to-white rounded-2xl p-8 border-2 border-blue-100 hover:border-blue-300 transition-all duration-300"
            >
              <div className="w-20 h-20 bg-blue-600 rounded-2xl flex items-center justify-center mb-6 shadow-lg">
                <i className={`${benefit.icon} text-4xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {benefit.title}
              </h3>
              <p className="text-gray-700 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        {/* Image Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <img 
              src="https://public.readdy.ai/ai/img_res/28ee7d56fb706a8de3eb9a3aa5301263.jpg"
              alt="プリンター機種"
              className="rounded-2xl shadow-2xl w-full h-auto"
            />
          </div>
          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-6">
              豊富な機種ラインナップ
            </h3>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              小規模オフィスから大企業まで、あらゆるニーズに対応できる豊富な機種をご用意しています。カラー印刷、モノクロ印刷、高速印刷など、用途に合わせてお選びいただけます。
            </p>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-check-double-line text-2xl text-blue-600 mt-1"></i>
                <span className="text-gray-700">最新機種を常時ラインナップ</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-double-line text-2xl text-blue-600 mt-1"></i>
                <span className="text-gray-700">用途に合わせた最適な機種をご提案</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-check-double-line text-2xl text-blue-600 mt-1"></i>
                <span className="text-gray-700">機種変更も柔軟に対応可能</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
